import { useList } from 'storfox-api-hooks'

import * as API from '../constants/api'

function useFilterList () {
  return useList(API.FILTER_LIST, {}, false)
}

export default useFilterList
